<template>
    <form action="#" method="post" class="form join-form" id='join-form'>
        <div class="block__wrap ">
            <ValidationObserver ref="accountDetailsInfoForm">
                <!--1-->
                <button class="block-toggle-ttl opener" type="button" data-toggle="collapse" data-target="#heading-1" aria-expanded="true" aria-controls="category">
                    <strong>Account Details</strong>
                    <div class="plus-minus"></div>
                </button>
                <div class="block-toggle-content collapse show" id="heading-1" aria-labelledby="block-toggle-ttl" style="">
                    <div class="row mb-0">
                        <ValidationProvider class="col-sm-12 col-md-6 wow" data-wow-delay="2.5s" name="First Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <label class="lbl lbl-required" for="first_name">First Name</label>
                                <input type="text" id="first_name" placeholder='First Name' class="form-control mb-1" v-model="user.first_name">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <ValidationProvider class="col-sm-12 col-md-6 wow" data-wow-delay="2.5s" name="Last Name" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <label class="lbl lbl-required" for="last_name">Last Name</label>
                                <input type="text" id="last_name" placeholder="Last Name" class="form-control mb-1" v-model="user.last_name">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <ValidationProvider class="col-sm-12 col-md-12 wow" data-wow-delay="2.5s" name="Position" rules="required|alpha_spaces|min:2|max:20" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <label class="lbl lbl-required" for="position">Title Position</label>
                                <input type="text" id="position" placeholder="Position" class="form-control mb-1" v-model="user.title">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <ValidationProvider class="col-sm-12 col-md-6 wow" data-wow-delay="2.5s" name="Email Address" rules="required|email" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <label class="lbl lbl-required" for="email">Email Address</label>
                                <input type="email" id="email" placeholder='Email Address' class="form-control mb-1" v-model="user.email">
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                        <ValidationProvider
                            class="col-sm-12 col-md-6 wow"
                            data-wow-delay="2.5s"
                            name="Phone Number"
                            :rules="{
                                required: true,
                                regex: /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/
                            }"
                            v-slot="{ errors }"
                        >
                            <div class="form-group mb-0">
                                <label class="lbl lbl-required" for="cellphone">Phone Number</label>
                                <the-mask
                                    id="cellphone"
                                    placeholder="Phone Number"
                                    type="tel"
                                    class="form-control mb-1"
                                    mask="+1 (###) ###-####"
                                    v-model="user.cellphone"
                                >
                                </the-mask>
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
                <!--2-->
                <button class="block-toggle-ttl opener collapsed wow fadeInUp" data-wow-delay="0.2s" type="button" data-toggle="collapse" data-target="#heading-2" aria-expanded="false" aria-controls="category">
                    <strong>My Bio*</strong>
                    <div class="plus-minus"></div>
                </button>
                <div class="block-toggle-content collapse" id="heading-2" aria-labelledby="block-toggle-ttl" style="">
                    <div class="row mb-0">
                        <ValidationProvider class="col-sm-12 col-md-12 col-xl-12" name="Bio" rules="required|min:10|max:200" v-slot="{ errors }">
                            <div class="form-group mb-0">
                                <textarea rows="3" class="form-control pr-5 mb-1" placeholder='Type description here...' aria-label="bio description add here" v-model="user.bio"></textarea>
                                <i class="fas fa-times clear__x" @click="[user.bio = '']"></i>
                            </div>

                            <div class="form-group field-validation-error">
                                {{ errors[0] }}
                            </div>
                        </ValidationProvider>
                    </div>
                </div>
            </ValidationObserver>

            <!--Submit-->
            <div class="buttons-bottom">
                <a href="/account/dashboard" class="btn btn-transparent">Cancel</a>
                <a href="#" class="btn" @click="validate">Submit</a>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        name: "AccountDetails",
        props: {
            input_user: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                user: this.input_user
            }
        },
        mounted() {
            this.$refs.accountDetailsInfoForm.validate();
        },
        methods: {
            showLoading() {
                this.$swal.fire({
                    title: `Submitting your form`,
                    text: `Checking your data`,
                    icon: 'info',
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                })
            },
            showErrorMessage(errors) {
                this.$swal.fire({
                    title: `The form contains some errors!`,
                    text: errors.join(', '),
                    icon: 'error',
                })
            },
            sendRequest(route, form) {
                axios.post(route, form)
                    .then(response => {
                        if (response) {
                            this.$swal.close();

                            setTimeout(() => {
                                this.$swal.fire({
                                    title: `Success!`,
                                    text: 'The account details have been successfully updated',
                                    icon: 'success',
                                })
                            }, 500);
                        }
                    })
                    .catch(error => {
                        this.$swal.close();

                        setTimeout(() => {
                            this.$swal.fire({
                                title: `The form contains some errors!`,
                                text: error.response.data.errors[Object.keys(error.response.data.errors)[0]][0],
                                icon: 'error',
                            })
                        }, 500);
                    })
            },
            validate() {
                (async () => {
                    const form = this.$refs.accountDetailsInfoForm;
                    const valid = await form.validate()
                    const errors = [];

                    for (const errorsKey in form.errors) {
                        if (form.errors.hasOwnProperty(errorsKey)) {
                            if (form.errors[errorsKey].length) {
                                errors.push(errorsKey);
                            }
                        }
                    }

                    if (valid) {
                        this.showLoading();

                        setTimeout(() => {
                            this.sendRequest('/account/details', this.user);
                        }, 1000);
                    } else {
                        this.showErrorMessage(errors);
                    }
                })();
            },
        }
    }
</script>

<style scoped lang="less">
    .lbl.lbl-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding-left: 5px;
    }

    .lbl-big-required:after {
        content: '*';
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 18px;
        font-weight: 400;
        padding-left: 5px;
    }

    .field-validation-error {
        color: #d54141;
        font-family: Open Sans, sans-serif;
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 0;
    }
</style>
